module.exports = __webpack_public_path__ + "static/media/b4.e41f9fb8.ogg";